'use strict'

jQuery(document).ready(function($) {

	/**
	* Arrow movement in the Desktop header navigation
	*/

	$('.menu-item a').on( "click", function() {
		$(this).toggleClass('open');
	});

	/**
	 * SHARE ICONS in the header navigation
	 */

	// Dropdown items - Open / Close
	$('.navigation__socialicons > a').on( "click", function() {
		var id = $(this).attr('id');
		var covertedId = id.replace( '-desktop', '' ).replace( '-mobile', '' );
		var selectedDropdown = '.navigation__socialicons__dropdown--' + covertedId;

		if ($(selectedDropdown).hasClass('closed') == true) {
			$('.navigation__socialicons__dropdown').removeClass('open').addClass('closed').hide();
			$('.navigation__socialicons > a').removeClass('active');

			$(selectedDropdown).removeClass('closed');
			$(selectedDropdown).addClass('open');
			$(selectedDropdown).show();

			$(this).addClass('active');
		} else if ($(selectedDropdown).hasClass('open') == true) {
			$('.navigation__socialicons__dropdown').removeClass('open').addClass('closed').hide();
			$('.navigation__socialicons > a').removeClass('active');
		}
	});

});
